"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function loadPixelTrackingUrl(url) {
    var img = new Image();
    img.src = url;
    img.height = 0;
    img.width = 0;
    img.style.display = 'none';
    img.onload = function () {
        this.parentNode.removeChild(this);
    };
    document.body.insertBefore(img, document.body.firstChild);
}
exports.loadPixelTrackingUrl = loadPixelTrackingUrl;
//# sourceMappingURL=loadPixelTrackingUrl.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/utils/loadPixelTrackingUrl.js
// module id = 6016
// module chunks = 67